import script from "./SearchPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchPane.vue?vue&type=script&lang=ts&setup=true"

import "./SearchPane.vue?vue&type=style&index=0&id=783934bb&lang=scss"

const __exports__ = script;

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter});
